$mol_svg $mol_view
	dom_name \svg
	dom_name_space \http://www.w3.org/2000/svg
	font_size 16
	font_family \
	style_size *
